import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import { OverlayLoader } from "../../Components/Shimmers";
import Swal from "sweetalert2";
import RedeemOfferTermAndCondition from "./RedeemOfferComponent/RedeemOfferTermAndCondition";
import { axiosGet, axiosPost } from "../../Apis/axiosMethods";

const RedeemPointsDetails = () => {
    const { business_redeem_offer_id } = useParams();
    const { apiB2BURL, token } = useContext(ConfigContext);

    const [attributes, setAttributes] = useState([]);
    const [selectedAttribute, setSelectedAttribute] = useState(null);
    const [selectedAttributeId, setSelectedAttributeId] = useState(null);

    const [allGallery, setAllGallery] = useState([]);
    const [filteredGallery, setFilteredGallery] = useState([]);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

    const [offerInfo, setOfferInfo] = useState({});
    const [offerAdditionalInfo, setOfferAdditionalInfo] = useState([]);

    const [loading, setLoading] = useState(true);
    const [relatedImages, setRelatedImages] = useState([]);
    const [isAttributesLoaded, setIsAttributesLoaded] = useState(false);

    const business_id = localStorage.getItem("business_id");
    const business_user_id = localStorage.getItem("business_user_id");

    const headers = {
        token,
        businessid: String(business_id),
        businessuserid: String(business_user_id),
        Accept: "application/json",
        "Content-Type": "application/json",
    };

    const isGiftOffer = attributes.some((attr) => attr?.business_redeem_offer_group_title?.toLowerCase() === "gifts");

    const GetOfferAttributes = async () => {
        try {
            const response = await axiosGet(`/Dashboard/GetRedeemOfferAttributes`, { business_redeem_offer_id });

            if (response?.data?.success) {
                const data = response?.data?.data || [];

                setAttributes(data);

                if (data.length > 0) {
                    setSelectedAttribute(data[0]);
                    setSelectedAttributeId(
                        data[0]?.business_redeem_offer_attribute_id
                    );
                } else {
                    setSelectedAttribute(null);
                    setSelectedAttributeId(null);
                }

                setIsAttributesLoaded(true);
            } else {
                setAttributes([]);
                setSelectedAttribute(null);
                setSelectedAttributeId(null);
                setIsAttributesLoaded(true);
            }
        } catch (error) {
            console.log("error fetching attributes:", error);
            setAttributes([]);
            setSelectedAttribute(null);
            setSelectedAttributeId(null);
            setIsAttributesLoaded(true);
        }
    };

    const fetchGallery = async (attributeId = null) => {
        try {
            const params = {
                business_redeem_offer_id,
                ...(attributeId && {
                    business_redeem_offer_attribute_id: attributeId,
                }),
            };

            const response = await axiosGet(`/Users/GetOffersGallery`, params);

            if (response?.data?.success) {
                return response.data.data || [];
            }

            return [];
        } catch (error) {
            console.error("Error fetching gallery:", error);
            return [];
        }
    };

    const loadData = async () => {
        try {
            setLoading(true);

            const allImages = await fetchGallery();

            setAllGallery(allImages);
            setFilteredGallery(allImages);
            setSelectedImageIndex(0);

            const offerResponse = await axiosGet(`/Users/GetOfferDetails`, { business_redeem_offer_id });

            if (offerResponse?.data?.success) {
                setOfferInfo(offerResponse.data.data || {});
                setOfferAdditionalInfo(offerResponse?.data?.add_info || []);
            } else {
                setOfferInfo({});
                setOfferAdditionalInfo([]);
            }
        } catch (error) {
            console.error("Error loading data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchAttributeImages = async () => {
            if (
                isAttributesLoaded &&
                selectedAttribute?.business_redeem_offer_attribute_id
            ) {
                const attributeImages = await fetchGallery(
                    selectedAttribute.business_redeem_offer_attribute_id
                );

                if (attributeImages.length > 0) {
                    setFilteredGallery(attributeImages);
                } else {
                    setFilteredGallery(allGallery);
                }

                setSelectedImageIndex(0);
            } else if (isAttributesLoaded) {
                setFilteredGallery(allGallery);
                setSelectedImageIndex(0);
            }
        };

        fetchAttributeImages();
    }, [selectedAttribute, isAttributesLoaded]);

    const SendRequest = async () => {
        try {
            if (attributes.length > 0 && !selectedAttributeId) {
                Swal.fire({
                    title: "Attribute Required",
                    text: "Please select an attribute before redeeming.",
                    icon: "warning",
                    confirmButtonText: "Okay",
                });
                return;
            }

            const body = {
                business_id,
                business_user_id,
                business_redeem_offer_id: offerInfo?.business_redeem_offer_id,
            };

            if (selectedAttributeId) {
                body.business_redeem_offer_attribute_id = selectedAttributeId;
            }

            const response = await axiosPost(`/Users/RedeemRequest`, body);

            if (response?.data?.success) {
                const points = response?.data.points;

                Swal.fire({
                    title: "✅ Redemption Successful!",
                    html: `
                        <p>You have successfully redeemed <b>${points} points</b>.</p>
                        <p>🎉 Your reward will be processed shortly.</p>
                    `,
                    icon: "success",
                    confirmButtonText: "Okay",
                });
            } else {
                Swal.fire({
                    title: "False",
                    text: response.data.message,
                    icon: "warning",
                    confirmButtonText: "Okay",
                });
            }
        } catch (error) {
            console.error("Redeem error:", error);

            Swal.fire({
                title: "Error",
                text: "An error occurred while redeeming.",
                icon: "error",
                confirmButtonText: "Okay",
            });
        }
    };

    const handleAttributeSelect = async (attr) => {
        setSelectedAttribute(attr);
        setSelectedAttributeId(
            attr.business_redeem_offer_attribute_id
        );

        const attributeImages = await fetchGallery(
            attr.business_redeem_offer_attribute_id
        );

        if (attributeImages.length > 0) {
            setFilteredGallery(attributeImages);
        } else {
            setFilteredGallery(allGallery);
        }

        setSelectedImageIndex(0);
    };

    const handleThumbnailClick = (index) => {
        setSelectedImageIndex(index);
    };

    const handleRelatedImageClick = (imageUrl) => {
        const index = filteredGallery.findIndex(
            (img) =>
                img.business_redeem_offers_image_url === imageUrl
        );

        if (index !== -1) {
            setSelectedImageIndex(index);
        }
    };

    const formatPoints = (value) => {
        const number = Number(value);

        if (Number.isNaN(number)) {
            return value;
        }

        return number.toLocaleString();
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        loadData();
        GetOfferAttributes();
    }, [business_redeem_offer_id]);

    if (loading) {
        return (
            <div style={{ height: "75vh" }}>
                <OverlayLoader />
            </div>
        );
    }

    return (
        <main className="main">
            <div className="container">
                <nav
                    aria-label="breadcrumb"
                    className="breadcrumb-nav mb-4"
                >
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">
                                <i className="icon-home" />
                            </Link>
                        </li>

                        <li
                            className="breadcrumb-item active"
                            aria-current="page"
                        >
                            Redeem Points Details
                        </li>
                    </ol>
                </nav>

                <div className="row">
                    <div className="col-md-5">
                        <div className="card border-0 shadow-sm">
                            <div className="row p-3">
                                <div className="col-md-2">
                                    <div
                                        className="vertical-thumbnails"
                                        style={{
                                            maxHeight: "350px",
                                            overflowY: "auto",
                                            paddingRight: "8px",
                                        }}
                                    >
                                        {filteredGallery.map(
                                            (img, index) => (
                                                <div
                                                    key={
                                                        img.business__redeem_offers_image_id ||
                                                        index
                                                    }
                                                    className={`thumbnail-item mb-2 ${selectedImageIndex ===
                                                        index
                                                        ? "selected"
                                                        : ""
                                                        }`}
                                                    onClick={() =>
                                                        handleThumbnailClick(
                                                            index
                                                        )
                                                    }
                                                    style={{
                                                        border:
                                                            selectedImageIndex ===
                                                                index
                                                                ? "2px solid #007bff"
                                                                : "1px solid #ddd",
                                                        borderRadius: "4px",
                                                        padding: "4px",
                                                        cursor: "pointer",
                                                        backgroundColor:
                                                            "#fff",
                                                        transition:
                                                            "all 0.2s ease",
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            img.business_redeem_offers_image_url
                                                        }
                                                        alt={`Thumbnail ${index + 1
                                                            }`}
                                                        style={{
                                                            width: "100%",
                                                            height: "60px",
                                                            objectFit:
                                                                "contain",
                                                        }}
                                                    />
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>

                                <div className="col-md-10">
                                    <div
                                        className="main-image-container"
                                        style={{
                                            height: "350px",
                                            display: "flex",
                                            justifyContent:
                                                "center",
                                            alignItems: "center",
                                            border: "1px solid #eee",
                                            borderRadius: "4px",
                                            backgroundColor: "#fff",
                                            overflow: "hidden",
                                            position: "relative",
                                            padding: "15px 0px",
                                        }}
                                    >
                                        {filteredGallery.length > 0 ? (
                                            <ZoomableImage
                                                src={
                                                    filteredGallery[
                                                        selectedImageIndex
                                                    ]
                                                        ?.business_redeem_offers_image_url
                                                }
                                            />
                                        ) : (
                                            <div className="text-center text-muted">
                                                No image available
                                            </div>
                                        )}
                                    </div>

                                    {relatedImages.length > 0 && (
                                        <div className="related-images-section mt-4">
                                            <h6
                                                className="mb-3"
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                Related Images
                                            </h6>

                                            <div className="row g-2">
                                                {relatedImages.map(
                                                    (
                                                        relatedImg,
                                                        index
                                                    ) => (
                                                        <div
                                                            className="col-4 col-md-3"
                                                            key={index}
                                                        >
                                                            <div
                                                                className="related-image-item"
                                                                onClick={() =>
                                                                    handleRelatedImageClick(
                                                                        relatedImg.image_url
                                                                    )
                                                                }
                                                                style={{
                                                                    border: "1px solid #ddd",
                                                                    borderRadius:
                                                                        "4px",
                                                                    padding:
                                                                        "4px",
                                                                    cursor: "pointer",
                                                                    backgroundColor:
                                                                        "#fff",
                                                                    transition:
                                                                        "all 0.2s ease",
                                                                    height: "80px",
                                                                    display:
                                                                        "flex",
                                                                    alignItems:
                                                                        "center",
                                                                    justifyContent:
                                                                        "center",
                                                                }}
                                                            >
                                                                <img
                                                                    src={
                                                                        relatedImg.image_url
                                                                    }
                                                                    alt={`Related ${index +
                                                                        1
                                                                        }`}
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        objectFit:
                                                                            "contain",
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-7 product-single-details">
                        <h3
                            className="mb-0"
                            style={{ fontWeight: "normal" }}
                        >
                            {offerInfo?.business_redeem_offer_title}{" "}
                            {!isGiftOffer &&
                                selectedAttribute?.business_redeem_offer_attribute_label}
                        </h3>

                        <div
                            style={{
                                background: "#ccc",
                                width: "100%",
                                height: "1px",
                                marginTop: "10px",
                            }}
                        />

                        <div className="mt-2">
                            <span className="badge bg-info text-white">
                                Redeem Offer
                            </span>

                            {!isGiftOffer && (
                                <div className="offer_price_box mb-2 mt-2">
                                    <div className="offer_price">
                                        <span className="currency">
                                            Pts
                                        </span>

                                        <span className="main_price">
                                            {
                                                offerInfo?.business_redeem_offer_points
                                            }
                                        </span>
                                    </div>
                                </div>
                            )}

                            {isGiftOffer &&
                                attributes.length > 0 && (
                                    <div className="gift-points-section mt-3 mb-3">
                                        <div className="gift-points-options">
                                            {attributes.map((attr) => {
                                                const isSelected =
                                                    selectedAttributeId ===
                                                    attr.business_redeem_offer_attribute_id;

                                                return (
                                                    <button
                                                        key={
                                                            attr.business_redeem_offer_attribute_id
                                                        }
                                                        type="button"
                                                        className={`gift-point-option ${isSelected
                                                            ? "selected"
                                                            : ""
                                                            }`}
                                                        onClick={() =>
                                                            handleAttributeSelect(
                                                                attr
                                                            )
                                                        }
                                                    >
                                                        <span className="gift-point-value">
                                                            {formatPoints(
                                                                attr.business_redeem_offer_attribute_value
                                                            )}
                                                        </span>

                                                        <span className="gift-point-label">
                                                            pts
                                                        </span>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                            <button
                                className="btn btn-primary btn-sm mb-2 redeem-btn"
                                style={{
                                    borderRadius: "30px",
                                }}
                                onClick={SendRequest}
                            >
                                Redeem Now
                            </button>
                        </div>

                        {!isGiftOffer && attributes.length > 0 && (
                            <div className="attributes-section mb-2">
                                <div className="mr-2 mb-1">
                                    <b>
                                        Colours :{" "}
                                        {
                                            selectedAttribute?.business_redeem_offer_attribute_label
                                        }
                                    </b>
                                </div>

                                <div className="d-flex flex-wrap gap-3 mb-3">
                                    {attributes.map(
                                        (attr, index) => {
                                            const isSelected =
                                                selectedAttribute?.business_redeem_offer_attribute_id ===
                                                attr.business_redeem_offer_attribute_id;

                                            return (
                                                <div
                                                    key={
                                                        attr.business_redeem_offer_attribute_id
                                                    }
                                                    className="p-2 ml-2 attribute-item"
                                                    onClick={() =>
                                                        handleAttributeSelect(
                                                            attr
                                                        )
                                                    }
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title={
                                                        attr?.business_redeem_offer_attribute_label
                                                    }
                                                    style={{
                                                        border: isSelected
                                                            ? "3px solid #007bff"
                                                            : "2px solid #dee2e6",
                                                        borderRadius:
                                                            "8px",
                                                        cursor: "pointer",
                                                        display:
                                                            "inline-flex",
                                                        alignItems:
                                                            "center",
                                                        justifyContent:
                                                            "center",
                                                        boxShadow:
                                                            isSelected
                                                                ? "0 3px 8px rgba(0,123,255,0.3)"
                                                                : "0 2px 4px rgba(0,0,0,0.1)",
                                                        transition:
                                                            "all 0.3s ease",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: "30px",
                                                            height: "30px",
                                                            borderRadius:
                                                                "50%",
                                                            background:
                                                                attr?.business_redeem_offer_attribute_value ||
                                                                "#f8f9fa",
                                                            display:
                                                                "flex",
                                                            alignItems:
                                                                "center",
                                                            justifyContent:
                                                                "center",
                                                            fontSize:
                                                                "14px",
                                                            fontWeight:
                                                                "bold",
                                                            color: "#495057",
                                                        }}
                                                    >
                                                        {!attr?.business_redeem_offer_attribute_value && (
                                                            <span>
                                                                {index +
                                                                    1}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        }
                                    )}
                                </div>
                            </div>
                        )}

                        <div className="my-2">
                            {offerAdditionalInfo?.length > 0 &&
                                offerAdditionalInfo.map(
                                    (item, index) => (
                                        <div
                                            className="row"
                                            key={index}
                                        >
                                            <div
                                                className="col-4 font-weight-bold"
                                                style={{
                                                    marginBottom:
                                                        "5px",
                                                }}
                                            >
                                                {item.offer_key}
                                            </div>

                                            <div
                                                className="col-4 text-left text-black"
                                                style={{
                                                    marginBottom:
                                                        "5px",
                                                    fontWeight:
                                                        "normal",
                                                }}
                                            >
                                                {item.offer_value}
                                            </div>
                                        </div>
                                    )
                                )}
                        </div>

                        <p>
                            {
                                offerInfo?.business_redeem_offer_description
                            }
                        </p>

                        <hr className="divider mb-0 mt-0" />

                        {offerInfo?.about_offer && (
                            <div className="mt-2">
                                <h4>About This Item</h4>

                                <div
                                    className="offer_description_content"
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            offerInfo?.about_offer,
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>

                <RedeemOfferTermAndCondition
                    description={offerInfo}
                />
            </div>

            <style jsx>{`
                .vertical-thumbnails::-webkit-scrollbar {
                    width: 4px;
                }

                .vertical-thumbnails::-webkit-scrollbar-track {
                    background: #f1f1f1;
                }

                .vertical-thumbnails::-webkit-scrollbar-thumb {
                    background: #888;
                    border-radius: 2px;
                }

                .vertical-thumbnails::-webkit-scrollbar-thumb:hover {
                    background: #555;
                }

                .thumbnail-item:hover {
                    border-color: #007bff !important;
                    transform: scale(1.02);
                }

                .thumbnail-item.selected {
                    border-color: #007bff !important;
                    box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
                }

                .attribute-item:hover {
                    transform: scale(1.1);
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
                    transition: all 0.3s ease;
                }

                .attribute-item.selected {
                    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.3) !important;
                }

                .related-image-item:hover {
                    border-color: #007bff !important;
                    transform: scale(1.05);
                }

                .gift-points-section {
                    width: 100%;
                }

                .gift-points-options {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;
                }

                .gift-point-option {
                    min-width: 95px;
                    padding: 10px 16px;
                    border: 1px solid #dee2e6;
                    border-radius: 6px;
                    background: #fff;
                    color: #212529;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 500;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 4px;
                    transition: all 0.2s ease;
                }

                .gift-point-option:hover {
                    border-color: #007bff;
                    color: #007bff;
                    background: #f8fbff;
                }

                .gift-point-option.selected {
                    border: 2px solid #007bff;
                    background: #eef6ff;
                    color: #007bff;
                    box-shadow: 0 2px 6px rgba(0, 123, 255, 0.15);
                }

                .gift-point-value {
                    font-weight: 600;
                }

                .gift-point-label {
                    font-weight: 500;
                }

                @media (max-width: 767px) {
                    .gift-point-option {
                        min-width: 85px;
                        padding: 8px 12px;
                        font-size: 13px;
                    }
                }
            `}</style>
        </main>
    );
};

const ZoomableImage = ({ src }) => {
    const [scale, setScale] = useState(1);
    const [origin, setOrigin] = useState("50% 50%");

    const handleMouseMove = (e) => {
        const rect =
            e.currentTarget.getBoundingClientRect();

        const x =
            ((e.clientX - rect.left) / rect.width) * 100;

        const y =
            ((e.clientY - rect.top) / rect.height) * 100;

        setOrigin(`${x}% ${y}%`);
    };

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
                cursor: "zoom-in",
            }}
            onMouseEnter={() => setScale(2)}
            onMouseMove={handleMouseMove}
            onMouseLeave={() => setScale(1)}
        >
            <img
                src={src}
                alt="offer"
                style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    transform: `scale(${scale})`,
                    transformOrigin: origin,
                    transition: "transform 0.15s ease",
                }}
            />
        </div>
    );
};

export default RedeemPointsDetails;